import { render, staticRenderFns } from "./questionImport.vue?vue&type=template&id=c7c475e2&scoped=true&"
import script from "./questionImport.vue?vue&type=script&lang=js&"
export * from "./questionImport.vue?vue&type=script&lang=js&"
import style0 from "./questionImport.vue?vue&type=style&index=0&id=c7c475e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c475e2",
  null
  
)

export default component.exports